(function () {
  // Simple scroll spy active state
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.tpl-help-block');
    const navLinks = document.querySelectorAll('.tpl-help-nav__link');

    let scrollTick = false;
    window.addEventListener('scroll', () => {
      if (scrollTick) return;
      scrollTick = true;
      requestAnimationFrame(() => {
        let current = '';
        sections.forEach(section => {
          const sectionTop = section.offsetTop;
          if (scrollY >= sectionTop - 150) {
            current = section.getAttribute('id');
          }
        });

        navLinks.forEach(link => {
          link.classList.remove('is-active');
          if (link.getAttribute('href').includes(current)) {
            link.classList.add('is-active');
          }
        });
        scrollTick = false;
      });
    }, { passive: true });
  });
})();
